// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"15d326ce","561":"e207363b","985":"daee3ac3","992":"3d472db3"}[chunkId] + ".chunk.js";
};